/**
 * Uppercases text and removes diacritics (accents).
 * Works for Greek, Latin, and mixed content.
 */
export function uppercaseText(text: string): string {
  if (!text) return text
  const normalized = text.normalize("NFD")
  const withoutAccents = normalized.replace(/[\u0300-\u036f]/g, "")
  return withoutAccents.toUpperCase()
}
